module.exports = __webpack_public_path__ + "img/IMG_20220118_091851085_HDR.0687c6d8.jpg";